import axios from "axios";

export const urls = {
  login: "/api/auth/admin/login",
  logout: "",
  me: "/api/users/me",
};

export const authLogin = (data) => {
  return axios.post(urls.login, data, {
    headers: {
      doNotAddUserTokenAuthorization: true,
    },
  });
};

export const authLogout = () => {
  return axios.get(urls.logout);
};

export const authMe = () => {
  return axios.get(urls.me);
};
